// Cumbre asomándose por detrás de la caja de Crear (ADR-2026-10-09-asistente-en-crear), la
// de la propuesta "Cumbre asoma": se mece y dice algo en un globito.
//
// La pone la caja en su esquina de arriba a la derecha, DETRÁS del marco (z más bajo), así
// el borde blanco le tapa el cuerpo y sólo se ve la cabeza. En Imagen y Video ofrece ayuda
// (y el globito lleva al Asistente); en el Asistente aparece cuando el usuario empieza a
// escribir: "Te escucho…".

import React from 'react';
import { CumbreMascot } from '../../../../components/CumbreMascot';
import './crear.css';

export const CumbreQueAsoma: React.FC<{
  visible: boolean;
  /** Lo que dice. `onClick` lo vuelve botón; `fijo` lo deja quieto en vez de ir y venir. */
  globito?: { texto: string; onClick?: () => void; fijo?: boolean };
  className?: string;
}> = ({ visible, globito, className = '' }) => {
  const claseGlobito = `absolute bottom-[58%] right-[calc(100%-6px)] whitespace-nowrap rounded-[14px] rounded-br-[4px] bg-white px-3 py-1.5 text-[12.5px] font-semibold text-brand-primary shadow-[0_10px_24px_-12px_rgb(var(--brand-primary-rgb)_/_0.5)] md:px-3.5 md:py-2 md:text-[13px] ${
    globito?.fijo ? 'crear-globito--fijo' : 'crear-globito'
  }`;
  return (
    <div className={`crear-asoma ${className}`} data-visible={visible} aria-hidden={visible ? undefined : true}>
      <span className="crear-asoma-mece">
        {/* `cumbre--mini`: el flotado chico. Con el de 14 px subía tanto que asomaba el arco
            de las piernas por encima de la caja. */}
        <CumbreMascot decorativa size={104} className="cumbre--mini h-auto w-[64px] md:w-[104px]" />
      </span>
      {globito &&
        (globito.onClick ? (
          <button
            type="button"
            onClick={globito.onClick}
            tabIndex={visible ? undefined : -1}
            className={`${claseGlobito} transition-colors hover:bg-[rgb(var(--brand-primary-rgb)_/_0.07)]`}
          >
            {globito.texto}
          </button>
        ) : (
          <span className={claseGlobito}>{globito.texto}</span>
        ))}
    </div>
  );
};

export default CumbreQueAsoma;
